import { Component, inject } from '@angular/core';
import { LocalizationService } from '../../../core/localization/localization.service';
import { InfoHintComponent } from '../../../shared/design-system/info-hint.component';

@Component({
  standalone: true,
  selector: 'ain-form-builder-logic-panel',
  imports: [InfoHintComponent],
  template: `
    <section class="logic-panel card">
      <ain-info-hint
        [titleKey]="'dynamic.builder.logic.infoTitle'"
        [descriptionKey]="'dynamic.builder.logic.infoDescription'"
        [bulletKeys]="[
          'dynamic.builder.logic.infoBulletValidation',
          'dynamic.builder.logic.infoBulletVisibility',
          'dynamic.builder.logic.infoBulletComputed'
        ]" />
      <p class="hint">{{ t('dynamic.builder.logic.designHint') }}</p>
    </section>
  `,
  styles: [`
    .logic-panel { display: grid; gap: 12px; padding: 16px; }
    .hint { margin: 0; color: var(--text-color-secondary); }
  `]
})
export class FormBuilderLogicPanelComponent {
  private readonly localization = inject(LocalizationService);

  t(key: string): string {
    return this.localization.translate(key);
  }
}
